<template>
	<div class="my-schools">
		<ViewSchool />
		<ViewStudent />
		<ProcessFee />

		<div class="row">
			<div class="col-12 col-lg-6" v-if="schools.length > 0">
				<div class="title-content clearfix">
					<div class="title f-l">My Schools</div>
				</div>
				<div class="scroll-content">
					<scrollbar>
						<div
							class="intermediary-box"
							v-for="(school, i) in schools"
							:key="i"
							@click="viewSchool(school)"
						>
							<div class="clearfix">
								<div class="image-box f-l">
									<img
										:src="
											school.school_image_path
												? api.getDomain() +
													'/' +
													school.school_image_path
												: '/img/logo-1.png'
										"
										alt=""
										class="image"
									/>
								</div>
								<div class="name-box f-l">
									<div class="insurance">
										{{ school.school_name }}
									</div>
									<div class="txt">
										{{ school.school_description }}
									</div>
								</div>
							</div>
						</div>
					</scrollbar>
				</div>
			</div>
			<div
				class="col-12 col-lg-6"
				v-if="!schools || schools.length === 0"
			>
				<div class="white-content">
					<div class="title">No Schools Found.</div>
				</div>
			</div>
			<div class="col-12 col-lg-5">
				<Advert />
			</div>
		</div>
	</div>
</template>

<script>
import school from '../rsc/stores/my-schools.store';
import VueScrollbar from 'vue-scrollbar-simple';

export default {
	async beforeCreate() {
		Event.$emit('loader:show', true);
		let token = await $session.get('token');

		if (!token) {
			Event.$emit('token:not-found', true);
		}
	},
	beforeDestroy() {
		this.$store.unregisterModule('school');
	},
	created() {
		utils.registerModule('school', school, this.$store);
	},
	components: {
		Advert: () => import('../templates/ads/advert.vue'),
		ViewSchool: () => import('./view-school.vue'),
		ProcessFee: () => import('./process-fee.vue'),
		ViewStudentFeeStructure: () =>
			import('./view-student-fee-structure.vue'),
		ViewStudent: () => import('./view-student.vue'),
		scrollbar: VueScrollbar,
	},
	data() {
		return {
			clientType: '',
			api,
		};
	},
	computed: {
		...mapGetters(['loading', 'schools']),
	},
	methods: {
		...mapActions(['fetchData', 'viewSchool']),
	},
	async mounted() {
		utils.registerModule('school', school, this.$store);
		await this.fetchData();
	},
};
</script>

<style lang="less">
@grey: #a7abbd;

.my-schools {
	.scroll-content {
		height: calc(100vh - 230px);
	}
	.white-content {
		background: var(--white);
		border-radius: 4px;
		border: solid 1px #e6eaee;
		padding: 40px 0;
		text-align: center;
		font-size: 14px;
		font-weight: 600;
		color: var(--ne-red);
	}
	.intermediary-box {
		border-radius: 4px;
		border: solid 1px #e6eaee;
		background: var(--white);
		padding: 20px 15px;
		margin: 10px 0;
		cursor: pointer;

		.image-box {
			margin: 0 30px 0 0;

			.image {
				border-radius: 4px;
				width: auto;
				height: auto;
				max-width: 80px;
				max-height: 80px;
				margin: 5px 0 0 0;
			}
		}
		.insurer {
			color: var(--ne-blue);
			font-weight: 600;
			font-size: 12px;
		}
		.name-box {
			width: calc(100% - 120px);
			.insurance {
				font-size: 16px;
				color: var(--text-color);
				font-family: var(--font-bold);
				line-height: 15px;
				margin: 0 0 5px 0;
				text-transform: uppercase;
			}
			.txt {
				font-size: 13px;
			}
			.members {
				font-size: 13px;
				font-weight: 600;
				color: @grey;
				margin: 3px 0 10px 0;
			}
		}

		.status-box {
			.bx-green {
				font-size: 20px;
				line-height: 18px;
				font-family: var(--font-bold);
				margin: 5px 0 6px 0;

				.point {
					font-size: 11px;
				}
			}
			.txt {
				font-weight: 600;
				color: @grey;
			}
		}
	}
	.fee-card {
		&.student {
			.total {
				border: 0;
				margin: 0;
				padding: 0;
			}
		}
		.small-status {
			font-size: 13px;
			font-weight: 600;
			display: block;
		}
		.sum-total {
			.total {
				text-align: right;
				color: var(--ne-blue);
				font-size: 18px;
				font-weight: 600;
				padding: 10px 0 10px 30px;
				border-bottom: solid var(--text-color) 3px;
				border-top: solid var(--text-color) 3px;
			}
		}
		.term {
			margin: 0 0 40px 0;

			.name {
				font-size: 13px;
				font-weight: 600;
			}

			.small-title {
				font-size: 11px;
				font-weight: 600;
				margin: 10px 0 3px 5px;
			}
		}

		.price-item {
			font-size: 14px;

			.item-title {
			}
			.amount {
				text-align: right;
				font-weight: 600;
			}
		}
		.total-box {
			border-top: solid 1px var(--border-grey);
			border-bottom: solid 1px var(--border-grey);
			padding: 7px 0;
			margin: 10px 0 0 0;
			font-weight: 600;

			.amount {
				color: var(--ne-blue);
				text-align: right;
			}
		}

		.status {
			font-size: 12px;
			text-transform: uppercase;
			font-weight: 600;

			&.tx-yellow {
				color: var(--ne-yellow);
			}
		}
		.ref {
			font-size: 13px;
			text-transform: uppercase;
			font-weight: 600;
		}
		.class {
			font-size: 13px;
			text-transform: uppercase;
			font-weight: 600;
		}
		.time {
			font-size: 13px;
			color: var(--ne-green);
		}

		.s-class {
			color: #9c7bfc;
			font-size: 13px;
		}
		.total {
			color: var(--ne-blue);
			font-size: 15px;
			font-weight: 600;
			padding: 0 0 10px 0;
			margin: 0 0 20px 0;
			border-bottom: solid 1px var(--border-grey);
		}
	}
}
</style>
